<template>
  <section>
    <p class="better-menu-label fs-4 d-flex align-items-center mb-1">
      <SharedWithUsersIcon class="mr-2" :height="20" :width="21"/> My Groups
      <span class="my-tag">{{ filteredGroups.length }}</span>
    </p>
    <input type="text" class="input mt-1" v-if="filteredGroups.length > 8" v-model="groupQuery" placeholder="Filter groups">

    <Loader v-if="loading"/>
    <div v-else>
      <ul class="menu-list scroll-container" v-if="filteredGroups.length > 0" >
        <li v-for="g in filteredGroups">
          <router-link class="is-primary d-flex align-items-center flex-wrap break-word" :to="'/groups/' + g.id" >

            {{ g.name }}
          </router-link>
        </li>
      </ul>
      <p class="text-muted italic p-2" v-else>No groups</p>
    </div>
  </section>
</template>

<script>
import Loader from './Loader.vue'
import SharedWithUsersIcon from './SharedWithUsersIcon.vue'

import store from '../store.js'

const matchQuery = ({ title, description }, query) => {
  if (title == null) {
    title = ''
  }
  if (description == null) {
    description = ''
  }
  const removeAccents = x => x.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  const normalize = (x = '') => removeAccents(x).replace(/(\W|_)/g, '').toLowerCase()

  title = normalize(title)
  description = normalize(description)
  query = normalize(query)

  return title.includes(query) || description.includes(query)
}

export default {
  name: 'TeamsSection',
  components: {
    Loader,
    SharedWithUsersIcon,
  },
  data () {
    return {
      groupQuery: '',
    }
  },
  mounted () {
    store.dispatch('fetchTeams')
  },
  computed: {
    groups () {
      return store.state.teams
    },
    filteredGroups () {
      return this.groups.filter(x => matchQuery(x, this.groupQuery) && x.is_member)
    },
    loading () {
      return store.state.loadingTeamData
    },
  },
}

</script>



// WEBPACK FOOTER //
// GroupsSection.vue?11f74236